<template>
    <div
        class="mr-md"
        :class="{ [additionalClass]: true, 'is-active': isChecked, 'is-disabled': disabled }"
        :title="disabledExplanation"
        @click.prevent="input"
    >
        <label class="checkbox">
            <input
                ref="checkbox"
                :checked="isChecked"
                type="checkbox"
                :disabled="disabled"
                :name="name"
                @input="input"
            >

            <div class="icon">
                <font-awesome-icon icon="check" class="text-base" />
            </div>

            <slot />
        </label>
    </div>
</template>

<script>
    export default {
        model: {
            prop: 'checked',
            event: 'input',
        },
        props: {
            name: {
                required: false,
                type: String,
                default: null,
            },
            value: {
                required: true,
                type: [String, Number],
            },
            checked: {
                required: true,
                type: [Array, Boolean],
            },
            disabled: {
                required: false,
                type: Boolean,
                default: false,
            },
            additionalClass: {
                required: false,
                type: String,
                default: '',
            },
            disabledExplanation: {
                type: String,
                default: null,
            },
        },
        computed: {
            isChecked() {
                if (this.checked instanceof Array) {
                    return this.checked.includes(this.value);
                }

                return this.checked;
            },
        },
        methods: {
            input() {
                if (this.disabled) {
                    return;
                }

                if (this.checked instanceof Array) {
                    const checked = this.checked.slice();
                    const found = checked.indexOf(this.value);
                    if (found !== -1) {
                        checked.splice(found, 1);
                    } else {
                        checked.push(this.value);
                    }

                    this.$emit('input', checked);
                    return;
                }

                this.$emit('input', ! this.checked);
            },
        },
    };
</script>